export const environment = {
  production: false,
  apiUrl: 'https://lacivert-tekne.heyhotel.ai/api'
};



